import styled, { css } from 'styled-components/macro'

export const ContentsContainer = styled.section`
  padding: 2rem 0 0 0;
  width: 100%;
`

const copyTextCss = (copyText: string) => {
  if (copyText !== '') {
    return css`
      float: left;
      padding-right: 20px;
      vertical-align: middle;
    `
  }
  return css``
}

export const ContentsTitleStyle = styled.h3<{ copyText: string }>`
  font-size: 1.5rem;
  color: #224fac;
  margin-bottom: 0.6rem;export 
  font-family: 'Montserrat';
  ${(props) => copyTextCss(props.copyText)}

  &:first-letter {
    text-transform: uppercase;
  }
`

export const Span = styled.span`
  font-size: 14px;
  font-weight: 500;
  padding-left: 20px;
  word-break: break-all;
`

export const Img = styled.img`
  vertical-align: middle;
  padding-right: 0.6rem;
  width: 65px;
`

export const Button = styled.button`
  padding: 0.4rem;
  font-size: 0.6rem;
  border: 1px solid #d7d7d8;
  background-color: #fdfbfb;
  border-radius: 0.2rem;
  float: right;
  :hover {
    padding: 0.4rem;
    font-size: 0.6rem;
    color: #fff;
    border: 1px solid #072558;
    background-color: #072558;
    border-radius: 0.2rem;
  }
`
